import PropTypes from 'prop-types';

export default {
  estimatedTotalView: PropTypes.object,
  asterisk: PropTypes.bool,
  isThirdPartyReservation: PropTypes.bool,
};
